import axios from 'axios'
import baseUrl from '../config'
import getToken from '../../utils/getToken'

export const hostFeedback = async data => {
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/host-feedback`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
  return response.data
}

export const volunteerFeedback = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios({
    method: 'post',
    url: `${baseUrl}/volunteer-feedback`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
  return response.data
}

export const fetchApplicationInfo = async params => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/fetch-application-info`, {
    params: { ...params, token }
  })
  return response.data
}

export const fetchHostCheckInInfo = async token => {
  const response = await axios.get(`${baseUrl}/fetch-host-checkin-info/${token}`)
  return response.data
}
